import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { RoutesKeys } from 'src/app/utils/routes';
import { ProfileMenuItems } from '../../../models/profile-menu-items/profile-menu-items';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Menu that opens when clicked in user photo profile (user profile header)
 */
export class ProfileMenuComponent {
  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;

  @Input() profileMenuItems!: ProfileMenuItems;
  RoutesKeys = RoutesKeys;

  /**
   * @constructor
   */
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  /**
   * User logout
   */
  onLogout() {
    this.authenticationService
      .logout()
      .then(() => this.router.navigate(['/login']));
  }
}
